import { IconButton, IconButtonProps, Tooltip, TooltipProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

type HoverableIconButtonProps = Omit<IconButtonProps, "aria-label"> & {
    label: string;
    tooltipProps?: TooltipProps;
}

const HoverableIconButton = forwardRef<HTMLButtonElement, HoverableIconButtonProps>(({
    label,
    tooltipProps,
    ...rest
}, ref) => {
    return (
        <Tooltip {...tooltipProps} label={label}>
            <IconButton ref={ref} aria-label={label} {...rest} />
        </Tooltip>
    )
});

export default HoverableIconButton